import Vue from 'vue'
import Vuex from 'vuex'
import createLogger from 'vuex/dist/logger';

import auth from './modules/auth'
import authorization from './authorization'
import settlements from './settlements'
import general from './general'
import rcm from './rcm'
import authorizationV2 from './authorizationV2'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'
const plugins = [];

if (debug) plugins.push(createLogger())

export default new Vuex.Store({
  modules: {
    auth,
    authorization,
    authorizationV2,
    settlements,
    general,
    rcm
  },
  plugins,
  strict: debug
})
